import styles from "./Timeline.module.scss";

type Props = {
  minutes: number;
};
const Timeline = ({ minutes }: Props) => {
  return (
    <div
      style={{
        top: `${(minutes / 60) * 100}%`,
        position: "absolute",
        width: "100%",
        zIndex: 5,
      }}
    >
      <div aria-hidden="true" className={styles["line"]}></div>
      <div aria-hidden="true" className={styles["point"]}></div>
    </div>
  );
};

export default Timeline;
